(function(){
  'use strict';

  var header=document.querySelector('.site-header');
  function onScroll(){
    if(header) header.classList.toggle('site-header--scrolled',window.scrollY>30);
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();

  var navToggle=document.querySelector('.nav-toggle');
  var navLinks=document.querySelector('.nav-links');
  if(navToggle&&navLinks){
    navToggle.addEventListener('click',function(){
      var expanded=this.getAttribute('aria-expanded')==='true';
      this.setAttribute('aria-expanded',String(!expanded));
      navLinks.classList.toggle('is-open');
      document.body.style.overflow=expanded?'':'hidden';
    });
    var links=navLinks.querySelectorAll('a');
    for(var i=0;i<links.length;i++){
      links[i].addEventListener('click',function(){
        navToggle.setAttribute('aria-expanded','false');
        navLinks.classList.remove('is-open');
        document.body.style.overflow='';
      });
    }
  }

  document.addEventListener('click',function(e){
    var link=e.target.closest('a[href^="#"]');
    if(!link)return;
    var target=document.querySelector(link.getAttribute('href'));
    if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});}
  });
})();
